import { useState, useEffect } from 'react';
import { getAllShowrooms } from '../actions/location-actions';
import { isValidArray } from '../components/utilities/validations';

/**
 * useBranchShowrooms
 * @param {Array} branchIDs - branch id(s) to fetch showroomss
 * @param {Array} fallback - fallback array of static showroom data
 * @param {Array} storeNumbers - array of store numbers to filter showrooms by
 * @returns Array of showroom data, error message if applicable
 */
export const useBranchShowrooms = (branchIDs, fallback = [], storeNumbers) => {
	const [showrooms, setShowrooms] = useState(fallback);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (!isValidArray(branchIDs)) return;

		const fetchShowrooms = async () => {
			try {
				const showroomsArray = await getAllShowrooms();
				if (showroomsArray?.showrooms) {
					let arrayByStoreNumber = [];

					const arrayByBranch = showroomsArray.showrooms?.filter((showroom) => branchIDs.includes(showroom.branch_id));
					if (isValidArray(storeNumbers)) {
						arrayByStoreNumber = showroomsArray.showrooms?.filter((showroom) => storeNumbers.includes(showroom.store_number));
					}

					setShowrooms([...arrayByBranch, ...arrayByStoreNumber]);
					setError(null);
				} else if (showroomsArray?.error) {
					setError(showroomsArray.error?.message);
				}
			} catch (error) {
				setError('Error fetching showroom data');
			}
		};

		fetchShowrooms();
		// eslint-disable-next-line react-hooks/exhaustive-deps -- need to stringify, otherwise causes endless loop
	}, [JSON.stringify(branchIDs), storeNumbers]);

	return { showrooms, error };
};
